import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { LinkPreviewViewer } from "./link-preview-viewer.js";
const LinkPreview = ({ node, nodeIndex, NodeViewContainer }) => {
  const { helpers } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(LinkPreviewViewer, { node, helpers }));
};
var link_preview_default = LinkPreview;
export {
  LinkPreview,
  link_preview_default as default
};
//# sourceMappingURL=link-preview.js.map

import "@wix/ricos/css/plugin-link-preview-viewer.global.css";